import { message } from 'antd'
import axios from 'axios'
import { getAuth, getIdToken } from 'firebase/auth'
import { useMutation, useQuery, useQueryClient } from 'react-query'

export function sleeper (ms) {
  return function (x) {
    return new Promise(resolve => setTimeout(() => resolve(x), ms))
  }
}

export const useGetEmployees = (filters) => {
  let params = {}

  Object.keys(filters).forEach(key => {
    if (filters[key]) {
      params = {
        ...params,
        [key]: filters[key]
      }
    }
  })

  const urlParams = new URLSearchParams(params).toString()

  return useQuery(
    ['employees', params],
    async () => axios.get(
      `${process.env.REACT_APP_API_URL}/talent/employees${urlParams.length ? '?' + urlParams : ''}`,
      {
        headers: {
          Authorization: `Bearer ${await getIdToken(getAuth().currentUser)}`,
          'X-Tenant-Id': process.env.REACT_APP_TENANT_ID
        }
      }
    )
      .then(res => res.data),
    {
      staleTime: 1000 * 60 * 5,
      onError: (error) => {
        message.error(`Failed to fetch employee: ${error.response.data.message}`)
      }
    }
  )
}
export const useGetSingleEmplyee = ({ employeeUid }) => {
  return useQuery(
    ['employee', employeeUid],
    async () => axios.get(
      `${process.env.REACT_APP_API_URL}/talent/employees/${employeeUid}`,
      {
        headers: {
          Authorization: `Bearer ${await getIdToken(getAuth().currentUser)}`,
          'X-Tenant-Id': process.env.REACT_APP_TENANT_ID
        }
      }
    )
      .then(res => res.data.data),
    {
      staleTime: 1000 * 60 * 5,
      enabled: !!employeeUid,
      onError: (error) => {
        message.error(`Failed to fetch employee: ${error.response.data.message}`)
      }
    }
  )
}

export const useUpdateTalentCompanyPerson = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ employeeUid, data }) => axios.put(
      `${process.env.REACT_APP_API_URL}/talent/employees/${employeeUid}/profile`,
      data,
      {
        headers: {
          Authorization: `Bearer ${await getIdToken(getAuth().currentUser, true)}`,
          'X-Tenant-Id': process.env.REACT_APP_TENANT_ID
        }
      }
    ).then(res => res.data.data),
    {
      onMutate: async (variables) => {
        await queryClient.cancelQueries(['employee', variables.employeeUid])
        const previousEmployee = queryClient.getQueryData(['employee', variables.employeeUid])
        if (previousEmployee) {
          queryClient.setQueryData(['employee', variables.employeeUid], {
            ...previousEmployee,
            talentCompanyPerson: {
              ...previousEmployee.talentCompanyPerson,
              ...variables.data
            }
          })
        }
        return { previousEmployee, employeeUid: variables.employeeUid }
      },
      onError: (error, variables, context) => {
        if (context?.previousEmployee) {
          queryClient.setQueryData(['employee', context.employeeUid], context.previousEmployee)
        }
        message.error(`Failed to update employee profile: ${error?.response?.data?.message || error.message}`)
      },
      onSuccess: () => {
        message.success('Successfully updated employee profile')
      },
      onSettled: (data, error, variables) => {
        queryClient.invalidateQueries(['employee', variables?.employeeUid])
        queryClient.invalidateQueries('employees')
        queryClient.invalidateQueries('reporting')
        queryClient.invalidateQueries('reportingDump')
      }
    }
  )
}
